<template>
	<div>
		<PageHeader
			:data="{
				name: 'Clients Import',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
				],
			}"
		/>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<LPDataImporter :tableName="'clients'" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import LPDataImporter from '@/components/lp-data-importer/LPDataImporter'
export default {
	name: 'ClientsImport',
	components: { PageHeader, LPDataImporter },
	data() {
		return {}
	},
	computed: {
		...mapState(['authUser']),
	},
}
</script>
